import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "./redirectURL";
import { IoMdAdd } from "react-icons/io";
import "../assets/css/inventorymanagement.css";
import { RiDeleteBin5Line } from "react-icons/ri"; 

const HolidayMaster = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");

  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("slider-25");
  const [sliderTitle, setSliderTitle] = useState("");

  const [rowData, setRowData] = useState([]);
  const [columnWithDefs, setColumnWithDefs] = useState([]);

  const [storeIdOptions, setStoreIdOptions] = useState([]);
  const [storeNameOptions, setStoreNameOptions] = useState([]);

  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [editFormData, setEditFormData] = useState({
    destination_store_id: "",
    destination_store_name: "",
    holiday_date: "",
  });

  // Get today's date in YYYY-MM-DD format for the date input min attribute
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const holidaysCols = [
      {
      headerName: "",
      field: "delete",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell", 
      cellRendererFramework: (params) => (
        <div style={{
          height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
        }}>
          <button
            title="Delete"
            style={{
              height: "30px",
              width: "60px",
              backgroundColor: "transparent",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => handleDelete(params.data)}
          >
            <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
          </button>
        </div>
      ),
    },
    {
      headerName: "Holiday On",
      field: "holiday_date",
      valueGetter: (params) => {
        if (!params.data?.holiday_date) return "";
        const d = new Date(params.data.holiday_date);
        return isNaN(d) ? params.data.holiday_date : d.toISOString().split("T")[0];
      },
    },
    { headerName: "Store / Warehouse Name", field: "destination_store_name", width: 180 },
    { headerName: "Store / Warehouse Code", field: "destination_store_id", width: 180 },
    { headerName: "Holiday Month No", field: "month", width: 140 },
    { headerName: "Calendar Year", field: "year", width: 140 },
    { headerName: "Holiday Day (Date)", field: "date", width: 140 },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  const handleDelete = (holidayData) => {
    setSelectedRow(holidayData);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
  };

  const getholidaysMasterData = async () => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post("masters/getHolidaysData", {});
      const data = response?.data?.data || [];
      setRowData(data);
      const names = (response?.data?.distinctStoreNames || []).map((v) => ({ label: v, value: v }));
      const storeOptions = response?.data?.storeOptions || [];
      setStoreIdOptions(storeOptions);   // reuse this state to hold combined options
      setStoreNameOptions(names);
      setColumnWithDefs(holidaysCols);

      setLoadshow("show-n");
      setOverlayBlock("show-n");
    } catch (error) {

      setLoadshow("show-n");
      setOverlayBlock("show-n");

      setRowData([]);
      setColumnWithDefs(holidaysCols);
      setShow(true);
      setBasicType("error");
      setBasicTitle("Failed to fetch Holidays data");
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  useEffect(() => {
    const getMainData = async () => {
      await getholidaysMasterData();
      setLoadshow("show-n")
      setOverlayBlock("show-n")
    }

    getMainData();
  }, []);

  const closeAlert = () => {
    setShow(false);
    setIsSliderOpen(false)
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
  };

  const closeSlider = () => {
    setIsSliderOpen(false);
    setSliderType(null);
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
  };

  const hideOverlySlideBlock = () => {
    setIsSliderOpen(false);
    setLoadshow("show-n");
    setOverlyBlock("show-n");
  };

  const resetFormData = () => {
    setEditFormData({
      destination_store_id: "",
      destination_store_name: "",
      holiday_date: "",
    });
  };

  const onClickAddNewProduct = async () => {
    resetFormData();
    setSliderType(1);
    setIsSliderOpen(true);
    setSliderCl("slider-25");
    setSliderTitle("Add New Holiday");
    setOverlyBlock("show-m");
  };

  const onSaveHoliday = async (e) => {
    if (!editFormData.holiday_date || !editFormData.destination_store_id || !editFormData.destination_store_name) {
      setShow(true);
      setBasicType("warning");
      setBasicTitle("Please select date, store id");
      return;
    }

    // Additional validation to ensure selected date is not in the past
    const selectedDate = new Date(editFormData.holiday_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time part for accurate comparison

    if (selectedDate < today) {
      setShow(true);
      setBasicType("warning");
      setBasicTitle("Cannot select past dates for holidays");
      return;
    }

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const payload = {
        holiday_date: editFormData.holiday_date, // yyyy-mm-dd
        destination_store_id: editFormData.destination_store_id,
        destination_store_name: editFormData.destination_store_name,
      };
      const resp = await redirectURL.post("masters/addHoliday", payload);

      if (resp?.data?.status === "success") {
        setShow(true);
        setBasicType("success");
        setBasicTitle("Holiday added");
        closeSlider();
        await getholidaysMasterData();
      } else {
        setShow(true);
        setBasicType("warning");
        setBasicTitle(resp?.data?.message || "Could not add holiday");
      }
    } catch (err) {
      console.error("Add holiday error:", err);
      setShow(true);
      setBasicType("error");
      setBasicTitle(err?.response?.data?.message || "Add holiday failed");
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const statusPanel = useMemo(() => ({
    statusPanels: [
      { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
      { statusPanel: "agTotalRowCountComponent", align: "center" },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" },
    ],
  }), []);

  const sideBar = useMemo(() => ({
    toolPanels: [
      { id: "columns", labelDefault: "Columns", labelKey: "columns", iconKey: "columns", toolPanel: "agColumnsToolPanel" },
      { id: "filters", labelDefault: "Filters", labelKey: "filters", iconKey: "filter", toolPanel: "agFiltersToolPanel" },
    ],
  }), []);

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setIsSliderOpen(false);
    resetFormData();
  };

const onClickingPopupDeleteBtn = async () => {
  setLoadshow("show-m");
  setOverlayBlock("show-m");
  const params = { 
    destination_store_id: selectedRow.destination_store_id,
    holiday_date: selectedRow.holiday_date
  };
  console.log("params ", params)
  
  try { 
    const response = await redirectURL.post("masters/deleteHoliday", params);
  
    if (response.data.status === "success") {
      await getholidaysMasterData();
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShowDeletePopup(false);
      setShow(true);
      setBasicType("success");
      setBasicTitle("Holiday Deleted Successfully");
    } else {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete Holiday");
    }
  } catch (error) {
    setShow(true);
    setBasicType("info");
    setBasicTitle("Failed to delete Holiday");
  }
};

  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setShowDeletePopup(false);
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          >
          </SweetAlert>
        </div>

        <div className="col-sm-12 text-right pr-0 mb-4">
          <button
            onClick={onClickAddNewProduct}
            style={{ backgroundColor: "#93385D", color: "#fff", border: "2px solid #93385D", marginRight: 15,borderRadius:5, padding:6 }}
          >
            <IoMdAdd style={{ color: "#fff", fontSize: "18px" }} />
            {" Add"}
          </button>
        </div>

        <div className="col-sm-12 p-0 pl-2 mt-6">
          <div className="ag-theme-alpine" style={{ height: 450, width: "100%" }}>
            <AgGridReact
              rowData={rowData}
              columnDefs={columnWithDefs}
              defaultColDef={defaultColDef}
              domLayout="normal"
              sideBar={sideBar}
              pagination
              statusBar={statusPanel}
              paginationPageSize={100}
              enableRangeSelection
              gridOptions={{ suppressHorizontalScroll: false }}
            />
          </div>
        </div>
        
        <div
          className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
          style={{ width: "25%" }}
        >
          <div className="slider-header-container d-flex justify-content-between">
            <p className="m-0p">{sliderTitle}</p>
            <p
              className="m-0p"
              style={{ cursor: "pointer" }}
              onClick={onClickingSliderCloseIcon}
            >
              X&nbsp;&nbsp;&nbsp;
            </p>

          </div>

          {sliderType === 1 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflowY: "auto",
                padding: 5,
              }}
            >
              <div className="panel-body" style={{ padding: "16px 20px", flex: 1, overflowY: "auto" }}>
                <div className="form-field" style={{ marginBottom: 16 }}>
                  <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
                    Holiday On <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="field-input"
                    type="date"
                    id="holidayDate"
                    min={getTodayDate()} // Restrict to today and future dates
                    value={editFormData.holiday_date || ""}
                    onChange={(e) => setEditFormData({ ...editFormData, holiday_date: e.target.value })}
                    style={{
                      width: "100%",
                      height: "44px",
                      border: "1px solid #e5e7eb",
                      borderRadius: 8,
                      padding: "0 12px",
                    }}
                    onClick={() => document.getElementById('holidayDate').showPicker?.()}
                  />
                </div>

                <div className="form-field" style={{ marginBottom: 16 }}>
                  <label style={{ display: "block", fontWeight: 600, marginBottom: 6 }}>
                    Destination Store Id <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="field-input"
                    value={editFormData.destination_store_id || ""}
                    onChange={(e) => {
                      const id = e.target.value;
                      const opt = storeIdOptions.find(o => o.value === id);
                      setEditFormData({
                        ...editFormData,
                        destination_store_id: id,
                        destination_store_name: opt?.name || ""   // auto-fill store name
                      });
                    }}
                    style={{
                      width: "100%",
                      height: "44px",
                      border: "1px solid #e5e7eb",
                      borderRadius: 8,
                      padding: "0 12px",
                    }}
                  >
                    <option value="">Select Option</option>
                    {storeIdOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label} {/* "D001 - Barkhana" */}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                  <button
                    className="btn-add"
                    onClick={onSaveHoliday}
                    style={{
                      padding: "10px 18px",
                      border: 0,
                      borderRadius: 8,
                      cursor: "pointer",
                      fontWeight: 700,
                      color: "#fff",
                      background: "#8a2d45",
                    }}
                  >
                    ADD
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Do you want to remove this holiday ${selectedRow ? selectedRow.destination_store_name : ""} on ${selectedRow ? new Date(selectedRow.holiday_date).toISOString().split("T")[0] : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
                style={{ marginRight: "10px" }}
              >
                Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};

export default HolidayMaster;